module.exports = __webpack_public_path__ + "files/62a61d85d13b10b8bbaea6aa03894694.png";